// One cache, one shape, for harvest_config. Three pages plus the offline
// prewarm used to fetch ['harvest-config', tenantId] with three DIFFERENT
// column lists — whichever ran last clobbered the cache for the others, so
// Capture could read default_unit_type as undefined (silently falling back
// to 'BIN' and dropping the photo gate) right after someone opened Day End.
// Every consumer imports this hook; never re-query harvest_config under this
// key with your own select (same rule as useTargetMarkets).
import { useQuery } from '@tanstack/react-query'
import { supabase } from '@/lib/supabase'
import { useActiveTenant } from '@/lib/useActiveTenant'
import type { HarvestConfigRow } from '@/lib/harvestForms'

export const HARVEST_CONFIG_SELECT =
  'tenant_id, default_unit_type, ticket_close_dow, ticket_period_days, ticket_anchor_close, require_pick_photo, require_gps, version'

const DAY_GC = 24 * 60 * 60 * 1000   // ≥ the offline persister's maxAge

export function useHarvestConfig() {
  const { data: activeTenant } = useActiveTenant()
  const tenantId = activeTenant?.tenantId ?? null
  return useQuery({
    queryKey: ['harvest-config', tenantId],
    enabled: !!tenantId, gcTime: DAY_GC, staleTime: 10 * 60 * 1000, networkMode: 'offlineFirst',
    queryFn: async () => {
      const { data, error } = await supabase.from('harvest_config')
        .select(HARVEST_CONFIG_SELECT)
        .eq('tenant_id', tenantId).maybeSingle()
      if (error) throw error
      return (data ?? null) as HarvestConfigRow | null
    },
  })
}
